<template>
  <PopupModal
    :open="open"
    class="bg-background"
    has-close-button
    @close="close"
  >
    <template #header>
      <p class="textHeadline3 mb-4">
        {{ $t("ssosbk.resendActivationMail.modal.title") }}
      </p>
    </template>
    <template #body>
      <form ref="form">
        <p class="mb-6">
          {{ $t("ssosbk.resendActivationMail.modal.hint") }}
        </p>
        <input
          id="email"
          v-model="email"
          required
          class="input-primary w-full"
          type="email"
          :placeholder="$t('ssosbk.resendActivationMail.modal.placeholder')"
        />
        <div
          v-if="resendMailError"
          class="cursor-pointer mt-2 w-full col-span-2 text-action-red"
        >
          {{ $t("ssosbk.resendActivationMail.modal.error") }}
        </div>
        <div
          v-if="resendMailSuccess"
          class="cursor-pointer mt-2 w-full col-span-2 text-action-green"
        >
          {{ $t("ssosbk.resendActivationMail.modal.success") }}
        </div>
      </form>
    </template>
    <template #footer>
      <button
        :class="[
          'button-bkk-100 w-full mt-2 !text-background mx-auto',
          resendMailBlocked ? 'button-disabled' : 'button-bkk-100',
        ]"
        :disabled="resendMailBlocked"
        @click="resendActivationMail"
      >
        {{ $t("ssosbk.resendActivationMail.modal.submit") }}
      </button>
    </template>
  </PopupModal>
</template>

<script>
import PopupModal from "../layout/PopupModal.vue";
import { resendActivation } from "~/api/sbk";

export default {
  name: "ResendActivationMailModal",
  components: { PopupModal },
  props: {
    open: Boolean,
  },
  emits: ["close"],
  data() {
    return {
      email: null,
      resendMailError: null,
      resendMailSuccess: false,
      resendMailBlocked: false,
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    async resendActivationMail() {
      const form = this.$refs.form;
      if (!form.reportValidity()) {
        return;
      }

      this.resendMailBlocked = true;
      await resendActivation(this.email)
        .then(() => {
          this.resendMailError = null;
          this.resendMailSuccess = true;

          // Prevent spamming resend mail
          setTimeout(() => {
            this.resendMailBlocked = false;
          }, 6000);
        })
        .catch((error) => {
          this.resendMailError = error;
          this.resendMailSuccess = false;
          this.resendMailBlocked = false;
        });
    },
  },
};
</script>
